import { Action } from './action';

export class ResetStore extends Action {
}
